import {type Page, type Pageable, toUrlParams} from "../util/pageable";
import {myAxios} from "../util/myAxios";
import type {Voucher} from "../entities/Voucher";
import {eventUrl} from './base';

export function getVouchers(
  pageable: Pageable
): Promise<Page<Voucher>> {
  return myAxios()
    .then(axios => axios.get(eventUrl(`/vouchers?`) + toUrlParams(pageable)))
    .then(response => response.data);
}
